export default "__VITE_ASSET__B3k61aT9__"